import { render, staticRenderFns } from "./CopyrightAssignmentTransferApplicationDetails.vue?vue&type=template&id=55f3645f&scoped=true&"
import script from "./CopyrightAssignmentTransferApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferApplicationDetails.vue?vue&type=style&index=0&id=55f3645f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f3645f",
  null
  
)

export default component.exports